module.exports = __webpack_public_path__ + "img/coin_1.99ccfd4c.png";